import { useAppSelector } from 'store';
import { composableFiltersState } from 'store/composableFiltersSlice';
import { AddFilterClause } from './AddFilterClause';
import { FilterClause } from './FilterClause';
import { NestedFilterClause } from './NestedFilterClause';

export const AdvancedFiltersGrid = () => {
  const { selected } = useAppSelector(composableFiltersState);

  const { conditions } = selected.filters;
  return (
    <div className="pr-4 mt-2 ml-10 mr-6 w-segments-800px ">
      <div className=" px-2 pt-1 border rounded-2xl  min-h-[442px]">
        {conditions.length ? (
          <>
            <div className="divide-y">
              {conditions.map((item, index) => {
                if ('mainOperator' in item) {
                  return (
                    <div key={item.key} className="py-3.5">
                      <NestedFilterClause data={item} index={index} />
                    </div>
                  );
                }

                return (
                  <div key={item.key} className="py-3.5">
                    <FilterClause data={item} index={index} />
                  </div>
                );
              })}
            </div>
            <div className="px-2">
              <AddFilterClause />
            </div>
          </>
        ) : (
          <NoFiltersPlaceholder />
        )}
      </div>
    </div>
  );
};

function NoFiltersPlaceholder() {
  return (
    <div className="flex flex-col items-center justify-center h-[435px]">
      <p className="max-w-xs text-center text-black text-segments-13px text-opacity-30">
        Start by selecting a segment above, or adding a custom filter
      </p>
      <div className="mt-3">
        <AddFilterClause />
      </div>
    </div>
  );
}
